import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import WidgetWithChart from '../../../components/kea/widgets/common/WidgetWithChart';
import { useLocalizedMessage } from '../../../util/useLocalizedMessage';

const formatNumber = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric.toLocaleString() : '—';
};

const sumProductViews = (records) => {
  if (!Array.isArray(records)) return null;
  return records.reduce((total, record) => {
    const views = Number(record?.count ?? record?.views ?? record?.total);
    return total + (Number.isFinite(views) ? views : 0);
  }, 0);
};

/** Cloud Home owns this richer summary; plugin Home keeps its operator cards. */
export default function CloudHomeMetrics({ queryPopular, popularByView }) {
  const t = useLocalizedMessage();
  const queries = queryPopular?.queries || {};
  const users = queryPopular?.users || {};
  const ctr = Number(queries.ctr);
  const views = sumProductViews(popularByView?.data);
  const metrics = [
    {
      id: 'queries',
      value: formatNumber(queries.total),
      title: t('cloud.home.metrics.queries.title'),
      description: t('cloud.home.metrics.queries.description'),
      tone: 'searches',
      loading: queryPopular?.isFetching || !queryPopular?.isFetched,
    },
    {
      id: 'users',
      value: formatNumber(users.total),
      title: t('cloud.home.metrics.users.title'),
      description: t('cloud.home.metrics.users.description'),
      tone: 'clickEvents',
      loading: queryPopular?.isFetching || !queryPopular?.isFetched,
    },
    {
      id: 'ctr',
      value: Number.isFinite(ctr) ? `${(ctr * 100).toFixed(1)}%` : '—',
      title: t('cloud.home.metrics.ctr.title'),
      description: t('cloud.home.metrics.ctr.description'),
      tone: 'clickRate',
      loading: queryPopular?.isFetching || !queryPopular?.isFetched,
    },
    {
      id: 'views',
      value: formatNumber(views),
      title: t('cloud.home.metrics.views.title'),
      description: t('cloud.home.metrics.views.description'),
      tone: 'lostOpportunities',
      loading: popularByView?.isFetching || !popularByView?.isFetched,
    },
  ];

  return (
    <Grid container spacing={3} data-testid="cloud-home-metrics">
      {metrics.map(metric => (
        <Grid item xs={12} sm={6} lg={3} key={metric.id}>
          <WidgetWithChart
            title={metric.title}
            mainNumber={metric.value}
            description={metric.description}
            tone={metric.tone}
            isFetching={metric.loading}
          />
        </Grid>
      ))}
    </Grid>
  );
}

CloudHomeMetrics.propTypes = {
  queryPopular: PropTypes.shape({
    isFetching: PropTypes.bool,
    isFetched: PropTypes.bool,
    queries: PropTypes.shape({}),
    users: PropTypes.shape({}),
  }).isRequired,
  popularByView: PropTypes.shape({
    isFetching: PropTypes.bool,
    isFetched: PropTypes.bool,
    data: PropTypes.array,
  }).isRequired,
};
